/**
 * When adding a new icon, you need to add the icon to the materialIcons object.
 * The object is used to map the icon name to the style and name.
 * The style is the style of the icon, either filled or outline.
 * The name is the name of the icon.
 * The fill is the fill of the icon, either 1 or 0.
 * The fill is used to determine if the icon should be filled or not.
 * The fill is 1 if the icon should be filled, 0 if it should be outline.
 * The fill is 1 if the icon should be filled, 0 if it should be outline.
 *
 * ----
 *
 * Once added, we will take the whole list of material icon names and create a new font with them.
 * To do so, just run `yarn icons:update` in the root of the UI-Library.
 */

export default {
  device_portrait: {
    name: 'mobile'
  },
  check_circle: {
    name: 'check_circle',
    fill: 1
  },
  'location_on-1': {
    name: 'location_on'
  },
  check_circle_transparent: {
    name: 'check_circle'
  },
  perfect_for_couples: {
    name: 'group'
  },
  arrow_left: {
    name: 'arrow_back'
  },
  arrow_right: {
    name: 'arrow_forward'
  },
  warning: {
    name: 'error'
  },
  nest_clock_farsight_analog: {
    name: 'nest_clock_farsight_analog'
  },
  progress_activity: {
    name: 'progress_activity'
  },
  arrow_full_bottom: {
    name: 'keyboard_arrow_down'
  },
  arrow_full_top: {
    name: 'keyboard_arrow_up'
  },
  arrow_full_right: {
    name: 'keyboard_arrow_right'
  },
  arrow_full_left: {
    name: 'keyboard_arrow_left'
  },
  done_check: {
    name: 'check'
  },
  content_copy_empty: {
    name: 'content_copy'
  },
  fav_line: {
    name: 'favorite'
  },
  key_locker: {
    name: 'key'
  },
  double_bed: {
    name: 'airline_seat_flat'
  },
  private_landlord: {
    name: 'location_away'
  },
  lock_closed: {
    name: 'lock'
  },
  help_circle: {
    name: 'help'
  },
  verified_card: {
    name: 'credit_score'
  },
  star: {
    name: 'star',
    fill: 1
  },
  stats_figures: {
    name: 'bar_chart'
  },
  format_list_bulleted: {
    name: 'format_list_bulleted'
  },
  diamond: {
    name: 'diamond'
  },
  savings: {
    name: 'savings'
  },
  proof_of_income: {
    name: 'request_quote'
  },
  id: {
    name: 'id_card'
  },
  more_horiz_circle: {
    name: 'pending',
    fill: 1
  },
  booking_request: {
    name: 'event_upcoming'
  },
  clock: {
    name: 'schedule'
  },
  check_shield: {
    name: 'beenhere',
    fill: 1
  },
  support_agent: {
    name: 'support_agent'
  },
  print: {
    name: 'print'
  },
  janitor_reception: {
    name: 'person_book'
  },
  cottage: {
    name: 'cottage'
  },
  call: {
    name: 'call'
  },
  exterior_picture: {
    name: 'image'
  },
  language: {
    name: 'language'
  },
  encrypted: {
    name: 'encrypted'
  },
  furnished: {
    name: 'chair'
  },
  add_box: {
    name: 'add_box'
  },
  envelope: {
    name: 'mail'
  },
  key_down: {
    name: 'key_vertical'
  },
  elevator: {
    name: 'elevator'
  },
  heating: {
    name: 'water_heater'
  },
  equipped_kitchen: {
    name: 'kitchen'
  },
  swimming_pool: {
    name: 'pool'
  },
  private_parking: {
    name: 'garage'
  },
  pets_allowed: {
    name: 'pet_supplies'
  },
  smoking_allowed: {
    name: 'smoking_rooms'
  },
  washing_machine: {
    name: 'local_laundry_service'
  },
  dryer: {
    name: 'local_laundry_service'
  },
  dishwasher: {
    name: 'dishwasher_gen'
  },
  oven: {
    name: 'oven_gen'
  },
  accessible: {
    name: 'accessible'
  },
  central_water_heating: {
    name: 'water_heater'
  },
  air_conditioning: {
    name: 'ac_unit'
  },
  private_bathroom: {
    name: 'soap'
  },
  desk_table: {
    name: 'desk'
  },
  balcony_terrace: {
    name: 'balcony'
  },
  tv: {
    name: 'tv'
  },
  interior_house: {
    name: 'window_open'
  },
  drawers: {
    name: 'dresser'
  },
  shelving: {
    name: 'shelves'
  },
  package: {
    name: 'package'
  },
  wardrobe: {
    name: 'dresser'
  },
  window: {
    name: 'window_closed'
  },
  electricity_bill: {
    name: 'electric_bolt'
  },
  water_drop: {
    name: 'water_drop'
  },
  gas_bill: {
    name: 'local_fire_department'
  },
  wifi: {
    name: 'wifi'
  },
  meal_service: {
    name: 'restaurant'
  },
  cleaning_service: {
    name: 'mop'
  },
  bank_court_house: {
    name: 'account_balance'
  },
  bed_linen: {
    name: 'toolbar' // blanket
  },
  single_bed: {
    name: 'airline_seat_flat'
  },
  twin_bed: {
    name: 'airline_seat_flat'
  },
  bunk_bed: {
    name: 'airline_seat_flat'
  },
  perfect_for_students: {
    name: 'school'
  },
  perfect_for_professionals: {
    name: 'business_center'
  },
  area_m2: {
    name: 'square_foot'
  },
  faster: {
    name: 'acute'
  },
  happy_face: {
    name: 'mood'
  },
  pets_not_allowed: {
    name: 'pet_supplies',
    negative: true
  },
  smoking_not_allowed: {
    name: 'smoke_free'
  },
  couples_allowed: {
    name: 'heart_smile'
  },
  cancel: {
    name: 'cancel'
  },
  female: {
    name: 'female'
  },
  male: {
    name: 'male'
  },
  person: {
    name: 'person'
  },
  calendar_month: {
    name: 'calendar_month'
  },
  close: {
    name: 'close'
  },
  map: {
    name: 'map'
  },
  euro: {
    name: 'euro'
  },
  person_add: {
    name: 'person_add'
  },
  partner_heart: {
    name: 'partner_heart'
  },
  hail: {
    name: 'hail'
  },
  description: {
    name: 'description'
  },
  'eye-filled': {
    name: 'visibility',
    fill: 1
  },
  fav_filled: {
    name: 'favorite',
    fill: 1
  },
  'person-filled': {
    name: 'person',
    fill: 1
  },
  shared: {
    name: 'ios_share'
  },
  schedule_send: {
    name: 'schedule_send'
  },
  verified: {
    name: 'verified'
  },
  add_moderator: {
    name: 'add_moderator'
  },
  delete_history: {
    name: 'delete_history'
  },
  event_available: {
    name: 'event_available'
  },
  animated_images: {
    name: 'animated_images'
  },
  smile: {
    name: 'sentiment_very_satisfied'
  },
  home_work: {
    name: 'home_work'
  },
  shower: {
    name: 'shower'
  },
  location_home: {
    name: 'location_home'
  },
  event_busy: {
    name: 'event_busy'
  },
  verified_user: {
    name: 'verified_user'
  },
  bed: {
    name: 'bed'
  },
  door_open: {
    name: 'door_open'
  },
  home: {
    name: 'home'
  },
  fast_rewind: {
    name: 'fast_rewind'
  },
  history: {
    name: 'history'
  }
};
